import Vue from 'vue'
const $http = Vue.prototype.$http
// 版本状态更新
function updateVersionState(data) {
  return $http({
    url: $http.adornUrl('/api/app/statusConvert'),
    method: 'post',
    data: $http.adornData(data)
  })
}
// 版本定时发布
function releaseVersion(data) {
  return $http({
    url: $http.adornUrl('/api/app/releaseBuildVersion'),
    method: 'post',
    data: $http.adornData(data)
  })
}
// 版本详情
function versionDetail(params) {
  return $http({
    url: $http.adornUrl('/api/app/getProductVersionMultiLanguage'),
    method: 'get',
    params: $http.adornParams(params)
  })
}
// 获取多语言列表所有语言描述信息
function allLanguages() {
  return $http({
    url: $http.adornUrl('/api/app/getAllLanguages'),
    method: 'get',
    params: $http.adornParams()
  })
}
// 获取公钥
function keys() {
  return $http({
    url: $http.adornUrl('/api/app/getKeys'),
    method: 'get',
    params: $http.adornParams()
  })
}

const httpMethods = { updateVersionState, versionDetail, releaseVersion, allLanguages, keys }
export default httpMethods
